// src/wizard/WizardShell.jsx
import React, { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db, auth } from "../firebase";

const brand = { green: "#00B074", gold: "#F4C542" };

export default function WizardShell({ onExit, children }) {
  const [txCount, setTxCount] = useState(0);
  const [isLinked, setIsLinked] = useState(false);

  // global tx counter
  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;
    const q = query(collection(db, "transactions"), where("userId", "==", user.uid));
    const unsub = onSnapshot(q, (snap) => setTxCount(snap.size));
    return () => unsub();
  }, []);

  // cheap “is linked?” check
  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;
    const unsub = onSnapshot(
      collection(db, "users", user.uid, "plaid", "items", "byId"),
      (snap) => setIsLinked(!snap.empty)
    );
    return () => unsub();
  }, []);

  return (
    <div style={{ maxWidth: 1100, margin: "1.5rem auto", padding: "1rem" }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"1rem" }}>
        <h2 style={{ margin: 0 }}>Budget Wizard</h2>
        <button
          onClick={onExit}
          style={{ border:"1px solid #ddd", padding:"0.5rem 0.75rem", borderRadius: 8, background:"#fff", cursor:"pointer" }}
        >
          Exit
        </button>
      </div>

      {/* persistent, non-blocking notice */}
      {isLinked && (
        <div style={{
          background:"#f7fdfb",
          border:"1px solid #d9f3ea",
          borderRadius:10,
          padding:"10px 12px",
          marginBottom:"12px"
        }}>
          <div style={{ fontWeight:700, color:"#0d7a3a" }}>We’re syncing your transactions in the background</div>
          <div style={{ fontSize:13, color:"#555", marginTop:4 }}>
            It takes time for Plaid and your bank to share everything. We’ll keep importing while you continue.
          </div>
        </div>
      )}

      {/* your current step renders here */}
      <div>{children}</div>

      {/* sticky bottom counter */}
      {isLinked && (
        <div style={{
          position:"fixed", left:0, right:0, bottom:12,
          display:"flex", justifyContent:"center", pointerEvents:"none", zIndex:999
        }}>
          <div
            style={{
              pointerEvents:"auto",
              background:"#111",
              color:"#fff",
              borderRadius:999,
              padding:"6px 12px",
              fontSize:13,
              boxShadow:"0 8px 20px rgba(0,0,0,0.18)",
            }}
            title="We’re still importing transactions from your bank in the background."
          >
            Importing transactions… <b>{txCount}</b> loaded so far
          </div>
        </div>
      )}
    </div>
  );
}